import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {DhiraaguEventTypes} from "./Events";

export enum DhiraaguEventContainerTypes {
    Journeys = "8868eb1e-8c9b-4e87-9fbb-0b5446efb865",
}

export const dhiraaguEventContainerTypeByEventType: Record<DhiraaguEventTypes, DhiraaguEventContainerTypes> = {
    [DhiraaguEventTypes.enquiry]: DhiraaguEventContainerTypes.Journeys,
    [DhiraaguEventTypes.call]: DhiraaguEventContainerTypes.Journeys,
    [DhiraaguEventTypes.sale]: DhiraaguEventContainerTypes.Journeys,
};

export const DHIRAAGU__EVENT_CONTAINER__CUSTOMER_NAME__COLUMN_ID = "07fd468b-4038-47e1-acdc-35060f145c5c" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__CONTACT_NUMBER__COLUMN_ID = "6f9cd758-96ea-4f56-9119-72802f4342cd" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__STATUS__COLUMN_ID = "a175b615-44eb-4fe7-a489-d52ca7a82ad0" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__ISLAND__COLUMN_ID = "84b573b2-4e51-4541-9e39-1f2db907e25f" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__ATOLL__COLUMN_ID = "d4ddd91f-555f-4037-bd35-ceb1810dad23" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__REGION__COLUMN_ID = "a268854c-afa0-4725-9c97-4310c5622e6b" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__ROCS__COLUMN_ID = "61effcad-8b80-42af-988a-e161f748e8d8" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__REMARKS__COLUMN_ID = "943b73fb-b75a-4fb5-90f5-daa3c1dc1d1b" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__GENDER__COLUMN_ID = "299c2941-45ca-41dd-94f0-0b17bb823933" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__ASSOCIATED_BEAT__COLUMN_ID = "92ff132c-9acd-43f1-aebe-403ffd560791" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__HOUSE_NUMBER__COLUMN_ID = "3a406da9-28db-40a2-a3a3-0cd1b5c7b2fb" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__AREA__COLUMN_ID = "0d037bf5-aefa-432c-bfed-006a1adb405f" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__LANDMARK__COLUMN_ID = "e47178ab-1521-43e0-b06f-be849def1d17" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__LAST_ACTIVITY__COLUMN_ID = "22703766-39fc-406e-a9e5-33434cb492bc" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__LAST_ACTIVITY_ON__COLUMN_ID = "7e370f85-c5ea-4aa3-8396-7588f1c18c50" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__LEAD_OWNER__COLUMN_ID = "09cd54b1-dac9-46a4-9d33-4e801e900b24" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__ENQUIRY_COUNT__COLUMN_ID = "44d7a3ac-0762-4946-a3a8-836f5584be81" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__CALLS_COUNT__COLUMN_ID = "22c70395-0823-4094-b5e8-dd3925c5bfd0" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__SALES_COUNT__COLUMN_ID = "ba183be9-29e5-451b-8c33-5c03f0f829dd" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__UTM_PLATFORM__COLUMN_ID = "11db7d6a-d7f7-4361-8902-ea35dd59f654" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__UTM_SOURCE__COLUMN_ID = "cc9da831-2c44-49e7-b0c8-178cd14d1a37" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__UTM_MEDIUM__COLUMN_ID = "75d79a0f-55d7-4086-b5a1-ce0dcd44083f" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__UTM_CAMPAIGN__COLUMN_ID = "3ad55014-ebb6-4ae4-8282-bb3a054e8cce" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__UTM_TERM__COLUMN_ID = "d86f0769-7853-4533-a488-9982973640bd" as Uuid;

export const DHIRAAGU__EVENT_CONTAINER__UTM_CONTENT__COLUMN_ID = "22321c65-9a35-43f9-93d7-a6af3498012f" as Uuid;

export enum DhiraaguEventContainerDispositionEnum {
    NEW_LEAD,
    NOT_CONNECTED_NOT_REACHABLE,
    NOT_CONNECTED_DEAD_LEAD,
    CONNECTED_VALID_LEAD_INTERESTED_PRODUCT_DETAILS_REQUIRED,
    CONNECTED_VALID_LEAD_INTERESTED_DEMO_REQUIRED,
    CONNECTED_VALID_LEAD_INTERESTED_FEASIBILITY_CHECK,
    CONNECTED_VALID_LEAD_INTERESTED_CUSTOM_PLAN_APPROVAL,
    CONNECTED_VALID_LEAD_INTERESTED_NOT_ELIGIBLE,
    CONNECTED_VALID_LEAD_INTERESTED_OTHER,
    CONNECTED_VALID_LEAD_NOT_INTERESTED_PRICE_ISSUE,
    CONNECTED_VALID_LEAD_NOT_INTERESTED_SERVICE_ISSUE,
    CONNECTED_VALID_LEAD_NOT_INTERESTED_COMPETITOR_PURCHASE,
    CONNECTED_VALID_LEAD_NOT_INTERESTED_OTHER,
    CONNECTED_CALL_BACK_LATER,
    CONNECTED_INVALID_LEAD_DID_NOT_FILL_DEAD_LEAD,
    CONNECTED_INVALID_LEAD_DID_NOT_FILL,
    CONNECTED_INVALID_LEAD_FILLED_BY_MISTAKE_DEAD_LEAD,
    CONNECTED_INVALID_LEAD_FILLED_BY_MISTAKE,
    WRONG_NUMBER,
}

export const DHIRAAGU__EVENT_CONTAINER__CREATE__FORM__ID = "7c3f4a1e-9b2d-4f8a-a5c6-2d1e8f9b3c4a" as Uuid;

export enum EventContainerStatusEnum {
    LIVE = "1a2b3c4d-5e6f-7a8b-9c0d-1e2f3a4b5c6d",
    CONVERTED = "2b3c4d5e-6f7a-8b9c-0d1e-2f3a4b5c6d7e",
    CHURNED = "3c4d5e6f-7a8b-9c0d-1e2f-3a4b5c6d7e8f",
    ARCHIVE = "4d5e6f7a-8b9c-0d1e-2f3a-4b5c6d7e8f9a",
}

export enum GenderEnum {
    MALE = "d705fdea-7188-40ed-b7ce-7d34efcac678",
    FEMALE = "1a83ec08-2fb7-4c43-885e-9f43e3cc4ef8",
    OTHER = "b82717fa-3b79-41de-8ef4-889c4d05cf44",
}

export const dhiraaguEventContainerDispositions: Record<DhiraaguEventContainerDispositionEnum, {
    id: Uuid,
    displayName: string,
    flatDisposition: string
}> = {
    [DhiraaguEventContainerDispositionEnum.NEW_LEAD]: {
        id: "a3b38e8d-4023-4f4e-8e4a-254e83964e82" as Uuid,
        displayName: "New Lead",
        flatDisposition: "new-lead"
    },
    [DhiraaguEventContainerDispositionEnum.NOT_CONNECTED_NOT_REACHABLE]: {
        id: "5be1d31c-c72d-4c60-86cf-ffa87ea5fe64" as Uuid,
        displayName: "Not Connected Not Reachable",
        flatDisposition: "not-connected_not-reachable"
    },
    [DhiraaguEventContainerDispositionEnum.NOT_CONNECTED_DEAD_LEAD]: {
        id: "4ba089f0-e230-488f-9ce7-0066384bbd19" as Uuid,
        displayName: "Not Connected Dead Lead",
        flatDisposition: "not-connected_dead-lead"
    },
    [DhiraaguEventContainerDispositionEnum.CONNECTED_VALID_LEAD_INTERESTED_PRODUCT_DETAILS_REQUIRED]: {
        id: "fa475f9c-54d4-4881-8680-4110b6807992" as Uuid,
        displayName: "Connected Valid Lead Interested Product Details Required",
        flatDisposition: "connected_valid-lead_interested_product-details-required"
    },
    [DhiraaguEventContainerDispositionEnum.CONNECTED_VALID_LEAD_INTERESTED_DEMO_REQUIRED]: {
        id: "271639b2-1485-4f46-80b8-de60381f3e98" as Uuid,
        displayName: "Connected Valid Lead Interested Demo Required",
        flatDisposition: "connected_valid-lead_interested_demo-required"
    },
    [DhiraaguEventContainerDispositionEnum.CONNECTED_VALID_LEAD_INTERESTED_FEASIBILITY_CHECK]: {
        id: "9ba13008-c2bf-44c0-b1ce-4e4fdbcbe351" as Uuid,
        displayName: "Connected Valid Lead Interested Feasibility Check",
        flatDisposition: "connected_valid-lead_interested_feasibility-check"
    },
    [DhiraaguEventContainerDispositionEnum.CONNECTED_VALID_LEAD_INTERESTED_CUSTOM_PLAN_APPROVAL]: {
        id: "59999fb2-2432-4581-a062-5b97fbfa9467" as Uuid,
        displayName: "Connected Valid Lead Interested Custom Plan Approval",
        flatDisposition: "connected_valid-lead_interested_custom-plan-approval"
    },
    [DhiraaguEventContainerDispositionEnum.CONNECTED_VALID_LEAD_INTERESTED_NOT_ELIGIBLE]: {
        id: "bb339cfd-b516-43f7-9fd2-6aca1ef10498" as Uuid,
        displayName: "Connected Valid Lead Interested Not Eligible",
        flatDisposition: "connected_valid-lead_interested_not-eligible"
    },
    [DhiraaguEventContainerDispositionEnum.CONNECTED_VALID_LEAD_INTERESTED_OTHER]: {
        id: "b514bc5f-2cab-4f3c-9b3b-10131c6a7066" as Uuid,
        displayName: "Connected Valid Lead Interested Other",
        flatDisposition: "connected_valid-lead_interested_other"
    },
    [DhiraaguEventContainerDispositionEnum.CONNECTED_VALID_LEAD_NOT_INTERESTED_PRICE_ISSUE]: {
        id: "ce1e491d-ca03-4a82-bed0-488737226477" as Uuid,
        displayName: "Connected Valid Lead Not Interested Price Issue",
        flatDisposition: "connected_valid-lead_not-interested_price-issue"
    },
    [DhiraaguEventContainerDispositionEnum.CONNECTED_VALID_LEAD_NOT_INTERESTED_SERVICE_ISSUE]: {
        id: "cdf5d423-7171-4986-8b6e-0b89fe5cf7cc" as Uuid,
        displayName: "Connected Valid Lead Not Interested Service Issue",
        flatDisposition: "connected_valid-lead_not-interested_service-issue"
    },
    [DhiraaguEventContainerDispositionEnum.CONNECTED_VALID_LEAD_NOT_INTERESTED_COMPETITOR_PURCHASE]: {
        id: "55e96346-6a62-4f28-a665-b5e9f6536b89" as Uuid,
        displayName: "Connected Valid Lead Not Interested Competitor Purchase",
        flatDisposition: "connected_valid-lead_not-interested_competitor-purchase"
    },
    [DhiraaguEventContainerDispositionEnum.CONNECTED_VALID_LEAD_NOT_INTERESTED_OTHER]: {
        id: "8c08c78a-ab8f-4be5-b339-3b6cd1fda865" as Uuid,
        displayName: "Connected Valid Lead Not Interested Other",
        flatDisposition: "connected_valid-lead_not-interested_other"
    },
    [DhiraaguEventContainerDispositionEnum.CONNECTED_CALL_BACK_LATER]: {
        id: "c9fbd999-2a08-45c0-9c86-41ab91f39d14" as Uuid,
        displayName: "Connected Call Back Later",
        flatDisposition: "connected_call-back-later"
    },
    [DhiraaguEventContainerDispositionEnum.CONNECTED_INVALID_LEAD_DID_NOT_FILL_DEAD_LEAD]: {
        id: "a7b869c5-3f7a-4ba0-8aba-eb4189a907ed" as Uuid,
        displayName: "Connected Invalid Lead Did Not Fill Dead Lead",
        flatDisposition: "connected_invalid-lead_did-not-fill_dead-lead"
    },
    [DhiraaguEventContainerDispositionEnum.CONNECTED_INVALID_LEAD_FILLED_BY_MISTAKE_DEAD_LEAD]: {
        id: "5196aefe-e8a7-4e70-9777-346f37680092" as Uuid,
        displayName: "Connected Invalid Lead Filled By Mistake Dead Lead",
        flatDisposition: "connected_invalid-lead_filled-by-mistake_dead-lead"
    },
    [DhiraaguEventContainerDispositionEnum.WRONG_NUMBER]: {
        id: "22b54240-872a-4b57-a312-197a701ef7a2" as Uuid,
        displayName: "Wrong Number",
        flatDisposition: "wrong-number"
    },
    [DhiraaguEventContainerDispositionEnum.CONNECTED_INVALID_LEAD_DID_NOT_FILL]: {
        id: "f110dd8d-96a1-450c-b91f-82beecaf68d8" as Uuid,
        displayName: "Connected Invalid Lead Did Not Fill",
        flatDisposition: "connected_invalid-lead_did-not-fill"
    },
    [DhiraaguEventContainerDispositionEnum.CONNECTED_INVALID_LEAD_FILLED_BY_MISTAKE]: {
        id: "f1008274-3cc7-4150-878e-8a66ca1641f6" as Uuid,
        displayName: "Connected Invalid Lead Filled By Mistake",
        flatDisposition: "connected_invalid-lead_filled-by-mistake"
    },
};

export const getDhiraaguEventContainerDispositions = () =>
    Object.values(dhiraaguEventContainerDispositions).map((disposition) => ({
        id: disposition.id,
        displayName: disposition.flatDisposition,
    }));

export const eventContainerStatuses: Record<EventContainerStatusEnum, {
    id: Uuid,
    displayName: string
}> = {
    [EventContainerStatusEnum.LIVE]: {
        id: "1a2b3c4d-5e6f-7a8b-9c0d-1e2f3a4b5c6d" as Uuid,
        displayName: "Live"
    },
    [EventContainerStatusEnum.CONVERTED]: {
        id: "2b3c4d5e-6f7a-8b9c-0d1e-2f3a4b5c6d7e" as Uuid,
        displayName: "Converted"
    },
    [EventContainerStatusEnum.CHURNED]: {
        id: "3c4d5e6f-7a8b-9c0d-1e2f-3a4b5c6d7e8f" as Uuid,
        displayName: "Churned"
    },
    [EventContainerStatusEnum.ARCHIVE]: {
        id: "4d5e6f7a-8b9c-0d1e-2f3a-4b5c6d7e8f9a" as Uuid,
        displayName: "Archive"
    },
};

export const genders: Record<GenderEnum, {
    id: Uuid,
    displayName: string
}> = {
    [GenderEnum.MALE]: {
        id: GenderEnum.MALE as Uuid,
        displayName: "Male"
    },
    [GenderEnum.FEMALE]: {
        id: GenderEnum.FEMALE as Uuid,
        displayName: "Female"
    },
    [GenderEnum.OTHER]: {
        id: GenderEnum.OTHER as Uuid,
        displayName: "Other"
    },
};

export const DHIRAAGU_UTM_PLATFORM_OPTIONS = [
    "Website",
    "Facebook",
    "Instagram",
    "WhatsApp",
    "Walk-in",
] as const;

export type DhiraaguUtmPlatform = typeof DHIRAAGU_UTM_PLATFORM_OPTIONS[number];
